//@flow

import {bulkDeleteApi, bulkEditApi} from './api';

export function bulkDeleteProductService(productIds: string[]) {
  return bulkDeleteApi({productIds}).toPromise();
}

export function bulkEditProductService(data: any) {
  const dataFormatProducts = {
    products: [...data],
  };
  return bulkEditApi(dataFormatProducts).toPromise();
}
